import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { takeLatest, put, call } from "redux-saga/effects";
import { ShowError, ShowSucess } from '../../_helper/helper';

import {
  createDeductionplan,
} from "../../_helper/services/deductionplan";
import { createEmployeeCustomDeductionPlanFail, createEmployeeCustomDeductionPlanSuccess } from './actions';
import { EMPLOYEE_CUSTOM_DEDUCTION_PLAN_CREATE } from './actionTypes';

function* onCreateEmployeeCustomDeductionPlan({ payload }) {
  try {
    const response = yield call(createDeductionplan, payload);
    yield put(createEmployeeCustomDeductionPlanSuccess(response));
    ShowSucess('Deductions Added successfully', {
      position: 'top-right'
    });

  } catch (error) {
    yield put(createEmployeeCustomDeductionPlanFail(error.response));
    ShowError(error?.response?.data?.message);
  }
}

function* CartSaga() {
  yield takeLatest(EMPLOYEE_CUSTOM_DEDUCTION_PLAN_CREATE, onCreateEmployeeCustomDeductionPlan);
}

export default CartSaga;